import React, { useState } from "react";
import cn from "classnames";
import { Link } from "react-router-dom";
import styles from "./control.module.sass";
import Modal from "../../../../../../components/Modals/ModalComponent";
import CreatePayout from '../../../../../../components/EngageComponents/PlayersComponent/Modals/CreatePayout'
import {ReactComponent as AddMetaIcon} from '../../../../../../media/images/icons/add_meta.svg'

const Control = ({className, access, type, width, activeIndex}) => {

  const [visibleModal, setVisibleModal] = useState(false);

  const actions = [
    {
      icon: "add",
      action: () => setVisibleModal(true),
    }
  ];

  return (
    <>
      <div className={cn(styles.control, className)}>
        {actions.map((x, index) => (
            <div className={styles.controlDiv}>
              <span>Add Payout</span>{!access && <span onClick={x.action} className={styles.addIcon}><AddMetaIcon /></span>}
            </div>
        ))}
      </div>
      <Modal visible={visibleModal} onClose={() => setVisibleModal(false)}>
        <CreatePayout activeIndex={activeIndex} onClose={() => setVisibleModal(false)}/>
      </Modal>
    </>
  );
};

export default Control;
